import { render, staticRenderFns } from "./AllList.vue?vue&type=template&id=3c981457&lang=pug"
import script from "./AllList.vue?vue&type=script&lang=js"
export * from "./AllList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports